
import React from "react";
import { Link } from "react-router-dom";
import { NavbarBrand, Navbar, Container,Row,} from "reactstrap";

const AdminNavbar = () => {
  return (
    <>
      <Navbar className="navbar-top navbar-horizontal navbar-dark mobile-no-mb" expand="md" style={{backgroundColor:''}}>
        <Container className="px-4 justify-content-center">
          <Row>
          <NavbarBrand to="/" tag={Link} className="bg-yellowc" >
            <img
              alt="KJ Somaiya Logo"
              src={
                require("../../assets/img/kj.png").default
              }
            />
          </NavbarBrand>
          <h1 style={{display: 'inline-block'}} className="text-whitex no-w mr-3 mt-1 mobile-font-less">K. J. Somaiya Institute of Engineering and Technology</h1>
          <NavbarBrand to="/" tag={Link}>
            <img
              alt="Somaiya Trust Logo"
              src={
                require("../../assets/img/kj2.png").default
              }
            />
          </NavbarBrand>
          </Row>
          <button style={{display: 'none'}} className="navbar-toggler" id="navbar-collapse-main">
            <span className="navbar-toggler-icon" />
          </button>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
